import { Banner } from "@/ui/Banner";
import { Button, Col, Row } from "react-bootstrap";
import ExternalLink from "@/assets/ExternalLink.svg";

export const PageBanner = ({ className, title, content, buttonName, buttonUrl }) => {
  return (
    <Banner className={className} title={<h1>{title}</h1>} image={{ src: "/assets/banners/default.webp" }}>
      <Row>
        <Col xs={12} md={6}>
          {content && <div dangerouslySetInnerHTML={{ __html: content }} />}
          {buttonUrl && (
            <Button href={buttonUrl} className="mt-3 mt-md-0" variant="secondary">
              {buttonName}
              <ExternalLink className="ms-3" width="20" height="20" />
            </Button>
          )}
        </Col>
      </Row>
    </Banner>
  );
};

export default PageBanner;
